import React, {useEffect, useState} from 'react';
import {Canvas} from '@react-three/fiber';
import * as THREE from 'three';

import '../../styles/HeroSection/style.css';
import NewsletterSection from '../../components/NewsletterSection';
import HeroImage from './HeroImage';

const CloudtalHero = () => {
    const [popupType, setPopupType] = useState(null);

    const openPopup = (type) => {
        setPopupType(type);
    };

    const closePopup = () => {
        setPopupType(null);
    };

    useEffect(() => {
        const renderer = new THREE.WebGLRenderer({
            canvas: document.querySelector('canvas'),
            alpha: false,
        });

        renderer.setSize(300, 300, false);
    }, []);

    return (
        <section
            className="relative w-full min-h-screen bg-black text-white flex items-center pt-36 sm:pt-0 justify-center overflow-hidden">
            <div className="flex mx-auto items-center flex-col sm:flex-col-reverse">
                <div className="relative z-10 mx-auto text-center animate-[fadeUp_1.5s_ease_forwards] opacity-0">
                    <LabelButton/>
                    <h1 className="mt-5 text-2xl sm:text-7xl md:text-5xl font-extrabold tracking-tight animate-scalePulse w-[350px] sm:w-full text-ellipsis bg-gradient-to-r from-white to-green-300 bg-clip-text text-transparent drop-shadow-lg pb-[10px]">
                        Managed Cloud für KMUs, Startups und Einzelgänger
                    </h1>
                    <div className="px-5">
                        <p className="mx-auto text-zinc-100 text-base sm:text-xl max-w-xs sm:max-w-2xl text-ellipsis mt-5">
                            Serverless. Open-Source. 100% Deutsch. <span
                            className="text-ellipsis bg-gradient-to-b from-green-50 to-green-300 bg-clip-text text-transparent drop-shadow-lg">
                             Faire Preise</span>
                        </p>
                    </div>
                    <div className="flex flex-wrap gap-4 justify-center mt-8">
                        <button
                            onClick={() => openPopup('newsletter')}
                            className="
                            group
                            relative
                            inline-block
                            px-8 py-4
                            border
                            border-green-500
                            text-green-500
                            uppercase
                            font-bold
                            tracking-wider
                            rounded-full
                            overflow-hidden
                            transition
                            transform
                            duration-300
                            hover:scale-105
                            hover:shadow-[0_0_20px_rgba(0,255,0,0.7)]
                            mb-[20px]">
                            <div
                                className="absolute
                                inset-0
                                bg-gradient-to-r
                                from-transparent
                                via-green-500
                                to-transparent
                                opacity-20
                                transform
                                -translate-x-full
                                group-hover:translate-x-0
                                transition-transform
                                duration-500 ease-out"></div>
                            <span className="relative z-10">Beta-Tester werden</span>
                        </button>
                    </div>
                </div>
                <div className="absolute sm:relative top-0">
                    <Canvas
                        performance={{min: 0.5}}
                        gl={{
                            powerPreference: "high-performance",
                            alpha: true,
                        }}
                        shadows>
                        <HeroImage/>
                    </Canvas>
                </div>
            </div>

            {/* Newsletter-Popup */}
            {popupType === 'newsletter' && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                    <div className="bg-zinc-900 rounded-lg p-8 max-w-lg w-full text-center shadow-xl mx-4">
                        <h3 className="text-3xl font-bold mb-4 text-zinc-100">Exklusives Beta-Tester-Programm</h3>
                        <p className="mb-6 text-zinc-400">
                            Testen Sie als einer der wenigen unsere Beta-Version und erleben Sie die neuesten Funktionen vor allen anderen. Die Teilnehmerzahl ist streng limitiert – sichern Sie sich jetzt Ihren Platz!
                        </p>
                        <NewsletterSection
                            title=""
                            description=""
                            placeholder="Ihre E-Mail-Adresse"
                            buttonText="Jetzt registrieren"
                            privacyText="Wir respektieren Ihre Privatsphäre. Abmeldung jederzeit möglich."
                            additionalClassName="bg-bottom text-white !p-0 mb-4"
                        />
                        <button
                            onClick={closePopup}
                            className="mt-4 bg-zinc-800 text-zinc-200 px-6 py-2 rounded transition-transform duration-300 hover:scale-105"
                        >
                            Schließen
                        </button>
                    </div>
                </div>
            )}

            {/* Mehr Info-Popup */}
            {popupType === 'moreInfo' && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                    <div className="bg-zinc-900 rounded-lg p-8 max-w-2xl w-full text-center shadow-xl mx-4">
                        <h3 className="text-3xl font-bold mb-6 text-zinc-100">Weitere Informationen</h3>
                        <p className="mb-6 text-zinc-400">
                            Cloudtal bietet modernste Cloud-Dienste, die auf Leistung, Skalierbarkeit und Sicherheit
                            ausgelegt sind.
                        </p>
                        <ul className="list-disc list-inside text-left text-zinc-400 space-y-1">
                            <li>Leistungsstarke PostgreSQL-Datenbanken</li>
                            <li>DSGVO-konforme Cloud-Services</li>
                            <li>Skalierbare Lösungen für Ihr Unternehmen</li>
                            <li>Verlässliche Uptime und Sicherheit</li>
                            <li>Geplante Erweiterungen: Serverless-Dienste, Keycloak und mehr</li>
                        </ul>
                        <button
                            onClick={closePopup}
                            className="mt-6 bg-zinc-800 text-zinc-200 px-6 py-2 rounded transition-transform duration-300 hover:scale-105"
                        >
                            Schließen
                        </button>
                    </div>
                </div>
            )}
        </section>
    );
};


function LabelButton() {
    return (
        <div className="inline-block bg-gradient-to-r from-green-400 to-purple-500 p-[1px] rounded-full">
      <span
          className="flex items-center justify-center gap-2 rounded-full bg-black px-4 py-2 text-white transition hover:opacity-80 text-sm"
      >
        Powered by Green Energy
      </span>
        </div>
    );
}

export default CloudtalHero;
